<template>
  <v-card>
    <v-card-text>
      <form-group class="ma-0 pa-0 mt-3">
        <v-tabs
          v-model="tabs"
          vertical
        >
          <v-tab
            v-for="(tab, idx) in items"
            :key="'tab_'+idx"
          >
            {{ tab.text }}
          </v-tab>
          <v-tabs-items
            v-model="tabs"
            vertical
          >
            <v-tab-item
              v-for="(tab, idx) in items"
              :key="'tab_item_'+idx"
            >
              <v-card flat>
                <v-card-text>
                  <component
                    :is="tab.component"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </form-group>
    </v-card-text>
    <slot />
  </v-card>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import NotificationPushContent from 'Modules/contacard/communication/notifications/components/contents/NotificationPushContent.vue';
import NotificationEmailContent from 'Modules/contacard/communication/notifications/components/contents/NotificationEmailContent.vue';
import NotificationSmsContent from 'Modules/contacard/communication/notifications/components/contents/NotificationSmsContent.vue';

export default {
  name: 'NotificationMessageContent',
  components: {
    FormGroup, NotificationPushContent, NotificationEmailContent, NotificationSmsContent,
  },
  data: () => ({
    tabs: null,
    items: [
      {
        text: 'Push',
        component: 'NotificationPushContent',
      },
      {
        text: 'E-mail',
        component: 'NotificationEmailContent',
      },
      {
        text: 'SMS',
        component: 'NotificationSmsContent',
      },
    ],
  }),
  methods: {
    handleTab(tab) {
      this.tabs = tab;
    },
  },
};
</script>
